import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
const ɵ0 = () => import("./summary/summary.module.ngfactory").then(m => m.SummaryModuleNgFactory), ɵ1 = () => import("./app-mgmt/app-mgmt.module.ngfactory").then(m => m.AppManagementModuleNgFactory), ɵ2 = () => import("./messages-main/messages-main.module.ngfactory").then(m => m.MessagesMainModuleNgFactory), ɵ3 = () => import("./schedules/schedules.module.ngfactory").then(m => m.SchedulesModuleNgFactory), ɵ4 = () => import("./billings/billings.module.ngfactory").then(m => m.BillingsModuleNgFactory), ɵ5 = () => import("./campaigns/campaigns.module.ngfactory").then(m => m.CampaignsModuleNgFactory), ɵ6 = () => import("./tags/tags.module.ngfactory").then(m => m.TagsModuleNgFactory), ɵ7 = () => import("./coupons/coupons.module.ngfactory").then(m => m.CouponsModuleNgFactory), ɵ8 = () => import("./bookings/bookings.module.ngfactory").then(m => m.BookingsModuleNgFactory), ɵ9 = () => import("./calendars/calendars.module.ngfactory").then(m => m.CalendarModuleNgFactory), ɵ10 = () => import("./bots/bots.module.ngfactory").then(m => m.BotsModuleNgFactory), ɵ11 = () => import("./customer-care/customer-care.module.ngfactory").then(m => m.CustomerCareModuleNgFactory), ɵ12 = () => import("./menus/menus.module.ngfactory").then(m => m.MenusModuleNgFactory), ɵ13 = () => import("./locations/locations.module.ngfactory").then(m => m.LocationsModuleNgFactory), ɵ14 = () => import("./bulk-upload/bulk-upload.module.ngfactory").then(m => m.BulkUploadModuleNgFactory), ɵ15 = () => import("./events/events.module.ngfactory").then(m => m.EventsModuleNgFactory), ɵ16 = () => import("./members/members.module.ngfactory").then(m => m.MembersModuleNgFactory), ɵ17 = () => import("./sub-chats/sub-chats.module.ngfactory").then(m => m.SubChatsModuleNgFactory), ɵ18 = () => import("./sub-chats/sub-chats.module.ngfactory").then(m => m.SubChatsModuleNgFactory), ɵ19 = () => import("./sub-chats/sub-chats.module.ngfactory").then(m => m.SubChatsModuleNgFactory), ɵ20 = () => import("./settings/settings.module.ngfactory").then(m => m.SettingsModuleNgFactory), ɵ21 = () => import("./payments/payments.module.ngfactory").then(m => m.PaymentsModuleNgFactory), ɵ22 = () => import("./bundles/bundles.module.ngfactory").then(m => m.BundlesModuleNgFactory), ɵ23 = () => import("./packages/packages.module.ngfactory").then(m => m.PackagesModuleNgFactory), ɵ24 = () => import("./products/products.module.ngfactory").then(m => m.ProductsModuleNgFactory), ɵ25 = () => import("./mobile-store/mobile-store.module.ngfactory").then(m => m.MobileStoreModuleNgFactory), ɵ26 = () => import("./store-menu/store-menu.module.ngfactory").then(m => m.StoreMenuModuleNgFactory), ɵ27 = () => import("./upload-temps/upload-temps.module.ngfactory").then(m => m.UploadTempsModuleNgFactory), ɵ28 = () => import("./../../media-center/media-center.module.ngfactory").then(m => m.MediaCenterModuleNgFactory), ɵ29 = () => import("./blacklist/blackList.module.ngfactory").then(m => m.BlackListsModuleNgFactory), ɵ30 = () => import("./my-channel/mychannel.module.ngfactory").then(m => m.MyChannelNgFactory), ɵ31 = () => import("./white-list/white-list.module.ngfactory").then(m => m.WhitelistModuleNgFactory), ɵ32 = () => import("./map-service/mapService.module.ngfactory").then(m => m.MapServiceModuleNgFactory), ɵ33 = () => import("./map-routes/mapRoutes.module.ngfactory").then(m => m.MapRoutesModuleNgFactory), ɵ34 = () => import("./trips/trips.module.ngfactory").then(m => m.TripsModuleNgFactory), ɵ35 = () => import("./trips-history/trips-history.module.ngfactory").then(m => m.TripsHistoryModuleNgFactory), ɵ36 = () => import("./trips-notifiers/trips-notifiers.module.ngfactory").then(m => m.TripsNotifiersModuleNgFactory), ɵ37 = () => import("./mobile-workflow-store/mobile-workflow-store.module.ngfactory").then(m => m.MobileWorkFlowStoreModuleNgFactory), ɵ38 = () => import("./product/product.module.ngfactory").then(m => m.ProductModuleNgFactory), ɵ39 = () => import("./collections/collections.module.ngfactory").then(m => m.CollectionsModuleNgFactory), ɵ40 = () => import("./web-settings/web-settings.module.ngfactory").then(m => m.WebSettingsModuleNgFactory);
const routes = [
    {
        path: '',
        component: DashboardComponent,
        children: [
            {
                path: '',
                loadChildren: ɵ0
            },
            {
                path: 'app',
                loadChildren: ɵ1
            },
            {
                path: 'messages',
                loadChildren: ɵ2
            },
            {
                path: 'schedules',
                loadChildren: ɵ3
            },
            {
                path: 'billings',
                loadChildren: ɵ4
            },
            {
                path: 'campaigns',
                loadChildren: ɵ5
            },
            {
                path: 'tags',
                loadChildren: ɵ6
            },
            {
                path: 'coupons',
                loadChildren: ɵ7
            },
            {
                path: 'bookings',
                loadChildren: ɵ8
            },
            {
                path: 'calendars',
                loadChildren: ɵ9
            },
            {
                path: 'bots',
                loadChildren: ɵ10
            },
            {
                path: 'customercare',
                loadChildren: ɵ11
            },
            {
                path: 'polls',
                loadChildren: ɵ12
            },
            {
                path: 'locations',
                loadChildren: ɵ13
            },
            {
                path: 'bulkupload',
                loadChildren: ɵ14
            },
            {
                path: 'events',
                loadChildren: ɵ15
            },
            {
                path: 'users',
                loadChildren: ɵ16
            },
            {
                path: 'subgroups',
                loadChildren: ɵ17
            },
            {
                path: 'subchannels',
                loadChildren: ɵ18
            },
            {
                path: 'vapps',
                loadChildren: ɵ19
            },
            {
                path: 'settings',
                loadChildren: ɵ20
            },
            {
                path: 'transactions',
                loadChildren: ɵ21
            },
            {
                path: 'bundles',
                loadChildren: ɵ22
            },
            {
                path: 'packages',
                loadChildren: ɵ23
            },
            {
                path: 'products',
                loadChildren: ɵ24
            },
            {
                path: 'mStore',
                loadChildren: ɵ25
            },
            {
                path: 'storeMenu',
                loadChildren: ɵ26
            },
            {
                path: 'tempsupload',
                loadChildren: ɵ27
            },
            {
                path: 'mediacenter',
                loadChildren: ɵ28
            },
            {
                path: 'blackList',
                loadChildren: ɵ29
            },
            {
                path: 'my-channel',
                loadChildren: ɵ30
            },
            {
                path: 'wl',
                loadChildren: ɵ31
            },
            {
                path: 'MS',
                loadChildren: ɵ32
            },
            {
                path: 'MR',
                loadChildren: ɵ33
            },
            {
                path: 'Trips',
                loadChildren: ɵ34
            },
            {
                path: 'TH',
                loadChildren: ɵ35
            },
            {
                path: 'TN',
                loadChildren: ɵ36
            },
            {
                path: 'store',
                loadChildren: ɵ37
            },
            {
                path: 'product',
                loadChildren: ɵ38
            },
            {
                path: 'collections',
                loadChildren: ɵ39
            },
            {
                path: 'web-settings',
                loadChildren: ɵ40
            }
        ]
    }
];
export class DashboardRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31, ɵ32, ɵ33, ɵ34, ɵ35, ɵ36, ɵ37, ɵ38, ɵ39, ɵ40 };
